module.exports = __webpack_public_path__ + "static/img/sentence_2x.246e023.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rehabitation/sentence_2x.png
// module id = r5b2
// module chunks = 1